// Mirrors backend TaskResponseEnum (de.fsc.service.enums.TaskResponseEnum)
export const TASK_RESPONSE_POOR = 1;
export const TASK_RESPONSE_AVERAGE = 2;
export const TASK_RESPONSE_EXCELLENT = 3;

const TASK_RESPONSE_COLORS: Record<number, string> = {
  [TASK_RESPONSE_POOR]: "#DB3B3A",
  [TASK_RESPONSE_AVERAGE]: "#FFB010",
  [TASK_RESPONSE_EXCELLENT]: "#189B00",
};

const TASK_RESPONSE_ICONS: Record<number, string> = {
  [TASK_RESPONSE_POOR]: "face-frown",
  [TASK_RESPONSE_AVERAGE]: "face-meh",
  [TASK_RESPONSE_EXCELLENT]: "face-smile",
};

export function getTaskResponseColor(responseId?: number | null): string | undefined {
  if (!responseId) return undefined;
  return TASK_RESPONSE_COLORS[responseId];
}

export function getTaskResponseIcon(responseId?: number | null): string | undefined {
  if (!responseId) return undefined;
  return TASK_RESPONSE_ICONS[responseId];
}
